import { GoogleAnalytics } from "./ga";
export function loadPlugins() {
  // These are default or legacy plugins, these plugins are maintained
  new GoogleAnalytics();
}
